import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon, { iconTypes } from 'components/icon';

const forumTypes = {
  club: { title: 'Клуб', icon: iconTypes.club },
  contest: { title: 'Конкурс', icon: iconTypes.star },
  category: { title: 'Категория', icon: iconTypes.folder },
  product: { title: 'Продукт', icon: iconTypes.cart },
  forum: { title: 'Форум', icon: iconTypes.questionAnswer },
  forumDeveloper: { title: 'Форум застройщика', icon: iconTypes.questionAnswer },
  link: { title: 'Ссылка', icon: iconTypes.copyLink },
  stage: { title: 'Этап', icon: iconTypes.flag },
  person: { title: 'Пользователь', icon: iconTypes.person },
  persons: { title: 'Пользователи', icon: iconTypes.persons }
};

// Show icons for different forum type.
export default class ForumIcons extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    forumType: PropTypes.string,
    style: PropTypes.shape({})
  };

  render() {
    const { className, forumType = null, style } = this.props;

    if (!forumTypes[forumType]) {
      // eslint-disable-next-line
      console.error(`Передан несуществующий *forumType* - ${forumType}`);
      return null;
    }

    return (
      <Icon
        className={className}
        style={style}
        title={forumTypes[forumType].title}
        type={forumTypes[forumType].icon}
      />
    );
  }
}
